import ko from 'knockout';

ko.components.register('piediagram', {
    viewModel: function(params) {
        this.percentage = ko.observable(params && ko.unwrap(params.value) || 0);
        this.css = ko.observable(params && ko.unwrap(params.css));
        this.colorInner = ko.observable(params && ko.unwrap(params.colorInner) || 0);
        this.colorCircle = ko.observable(params && ko.unwrap(params.colorCircle) || 0);
        this.colorProgress = ko.observable(params && ko.unwrap(params.colorProgress) || 0);

        let defaults = {
            animateChange: true,
            showText: true,
            viewBox: '0 0 32 32',
            radiusOuter: 16,
            radiusInner: 12,
            cx: 16,
            cy: 16
        };

        this.options = Object.assign(params, defaults);

        this._style = ko.pureComputed(() =>
            "--pie-diagram-color-inner: " + this.colorInner() +
            "; --pie-diagram-color-circle:" + this.colorCircle() +
            "; --pie-diagram-color-progress:" + this.colorProgress() + ";");
    },
    template: `<div class="diagram pie position-relative" data-bind="attr: { style: _style }">
        <svg viewBox="0 0 32 32">
            <circle class="outer" r="16" cx="16" cy="16" data-bind="style: { 'stroke-dasharray': percentage() < 100 ? percentage() + ' 100' : '' }" />
            <circle class="inner" r="12" cx="16" cy="16" />
            </svg>
            <div data-bind="if: options.showText" class="position-absolute top-50 start-50 translate-middle text-nowrap">
                <strong data-bind="text: percentage"></strong>
                <small>%</small>
            </div>
    </div>`
})